import { Language } from './language';
import { SalesAgent } from './sales-agent';

export class UserForBackend {
    constructor(
        public name: string,
        public email: string,
        public password: string,
        public roles: string[],
        public isBanned: boolean,
        public slackId: string,
        public mainLanguage: Language | null,
        public hasDefaultLeadFilter: boolean,
        public id?: number
    ){}
}
